// extracted by mini-css-extract-plugin
export default {"filterWrapper":"ProductsComingSoon_filterWrapper__wB60H","filterButton":"ProductsComingSoon_filterButton__VPrM1","activeFilterButton":"ProductsComingSoon_activeFilterButton__ql4s-"};